// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ContractState, ContractViewModel } from '@ail/contracts-api'
import React, { Component } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { FrontendSettings } from '../../../../helpers/FrontendSettings'
import { defineContractStateNew } from '../../../../helpers/Utils'
import { wrapQuery } from '../../../../redux/api/apiQuery'
import { contractsApi } from '../../../../redux/api/contractsApi'
import { State } from '../../../../redux/reducers/initialState'
import { FrontendSettingsKeys } from '../../../../types/enums'
import { ICustomerViewModel, IDebounceState } from '../../../../types/interfaces'
import LicencePlateFlag from '../../LicencePlateFlag/LicencePlateFlag'
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner'

interface SearchingProps extends WithTranslation {
  customers?: ICustomerViewModel[]
  searchContracts?: (searchTerm?: string, activeOnly?: boolean) => Promise<ContractViewModel[]>
  changeTrigger?: (arg0: ContractViewModel) => void
  searchDeleted?: (nothing: string) => void
  formReadOnly?: boolean
  activeOnly?: boolean
  value?: string
}

interface SearchingState {
  startContractsSearching: boolean
  contractSearcLoading: boolean
  resultsDisplay: boolean
  contractsSearchDebounce: IDebounceState
  contractsSearchString: string
  contractsSearchStringToUse: string
  contractsSearcResults: ContractViewModel[]
}

class ContractsSearchComponent extends Component<SearchingProps, SearchingState> {
  private resultsRef: React.RefObject<any>
  constructor(props: SearchingProps) {
    super(props)
    this.state = {
      resultsDisplay: true,
      startContractsSearching: false,
      contractSearcLoading: false,
      contractsSearchDebounce: {
        change: 0,
      },
      contractsSearchString: '',
      contractsSearchStringToUse: '',
      contractsSearcResults: [],
    }
    this.contractsSearchChanged = this.contractsSearchChanged.bind(this)
    this.onKeyDownEvent2 = this.onKeyDownEvent2.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
  }

  componentDidMount() {
    this.resultsRef = React.createRef()
    if (this.props.value) {
      this.setState({
        contractsSearchString: this.props.value,
      })
    }
    document.addEventListener('mousedown', this.handleDocumentClick)
  }

  componentDidUpdate(oldProps: SearchingProps, oldState: SearchingState) {
    if (this.props.value !== oldProps.value) {
      this.setState({
        contractsSearchString: this.props.value,
      })
    }
    if (this.state.contractsSearchDebounce.change !== oldState.contractsSearchDebounce.change) {
      if (this.state.contractsSearchStringToUse !== this.state.contractsSearchString) {
        this.setState({
          contractsSearchStringToUse: this.state.contractsSearchString,
        })
      }
    }
    if (this.state.contractsSearchStringToUse !== oldState.contractsSearchStringToUse) {
      if (this.state.contractsSearchStringToUse && this.state.contractsSearchStringToUse.trim()?.length > 2) {
        this.setState({
          contractSearcLoading: true,
        })
        this.props.searchContracts?.(this.state.contractsSearchStringToUse, this.props.activeOnly).then(
          (resp) => {
            this.setState({
              contractSearcLoading: false,
              contractsSearcResults: resp,
            })
          },
          () => {
            this.setState({
              contractSearcLoading: false,
            })
          }
        )
      }
    }
  }

  render() {
    const { contractsSearchString, contractSearcLoading, contractsSearcResults, contractsSearchStringToUse } =
      this.state
    const customerDict = this.customersDictByUnit()
    const { t } = this.props
    const expiringDays = Number(FrontendSettings.get(FrontendSettingsKeys.expiringDaysFilter) ?? 90)
    return (
      <div ref={this.resultsRef} className="input-area contract-search">
        <input
          readOnly={this.props.formReadOnly}
          autoFocus={true}
          className="transparent"
          onBlur={(e) => !e.relatedTarget && e.target.focus()}
          type="text"
          name={`uniqueName${new Date().getTime()}`}
          autoComplete="off"
          placeholder={t('FIND_CONTRACT_BY_KEYWORD')}
          onChange={this.contractsSearchChanged}
          onKeyDown={this.onKeyDownEvent2}
          value={contractsSearchString}
        />
        <button title={t('CLEAR')} className="clr-btn" onClick={() => this.contractsSearchChanged()}>
          <span className="icon-clear" />
        </button>
        {contractSearcLoading && <LoadingSpinner color="#a8a8a8" size={18} className="contract-search-spinner" />}
        <i
          className="icon-search"
          onClick={() => this.onKeyDownEvent2({ target: { value: contractsSearchString }, key: 'Enter' } as any)}
        />
        <div className="search-res-wrap">
          {contractsSearcResults?.length === 0 &&
            !!contractsSearchStringToUse &&
            !!contractsSearchString &&
            contractsSearchString?.length >= 3 &&
            contractsSearchStringToUse === contractsSearchString &&
            !contractSearcLoading && (
              <div className="search-res-list">
                <div className="contract-item">
                  <span className="noResults">{t('NO_RESULTS_FOUND')}</span>
                </div>
              </div>
            )}
          {contractsSearcResults?.length > 0 && this.state.resultsDisplay && (
            <div className="search-res-list">
              {contractsSearcResults.slice(0, 50).map((c, key) => {
                return (
                  <div className="contract-item" key={key}>
                    <NavLink
                      onClick={(e) =>
                        this.props.changeTrigger ? this.handleChange(c, e) : this.contractsSearchChanged()
                      }
                      to={`/${
                        c.state === ContractState.Initialized ? 'orderAndDelivery' : 'generalContracts'
                      }/details/${c.id}`}
                    >
                      <span className="base-info">
                        <span>
                          {this.highlightText(c.reference, contractsSearchString)}
                          {` ${c.vehicle?.licencePlate?.licenseNumber ? '' : ' '}`}
                          <span className="gallikerInfo">
                            {this.highlightText(c.vehicle?.gallikerReference, contractsSearchString)}
                          </span>
                        </span>
                        <label
                          className={`statusArea ${
                            c.state === 'Initialized' && !!c.vehicle?.chassisNumber
                              ? 'settingup'
                              : defineContractStateNew({
                                  contract: c,
                                  status: undefined,
                                  endDate: undefined,
                                  expDays: expiringDays,
                                })?.toLowerCase()
                          }`}
                        >
                          {t(
                            `CONTRACT_${
                              c.state === 'Initialized' && !!c.vehicle?.chassisNumber
                                ? 'SETTINGUP'
                                : defineContractStateNew({
                                    contract: c,
                                    status: undefined,
                                    endDate: undefined,
                                    expDays: expiringDays,
                                  })?.toLowerCase()
                            }`.toUpperCase()
                          )}
                        </label>
                      </span>
                      <span className="car-info">
                        <span className="infoArea">
                          <span className="driver-info">
                            {this.highlightText(
                              !!c.vehicle?.driver?.displayName && !c.poolCar
                                ? c.vehicle?.driver?.displayName
                                : !c.poolCar && !c.vehicle?.driver?.displayName
                                ? t('NOT_ASSIGNED')
                                : c.poolCar && !!c.location
                                ? `${t('POOL_CAR')} | ${c.location}`
                                : c.poolCar && (!c.location || !!c.vehicle?.driver?.displayName)
                                ? `${t('POOL_CAR')}`
                                : '',
                              contractsSearchString
                            )}
                          </span>
                          <span className="vehicle-info" title={c.vehicle?.description}>
                            {c.vehicle?.description}
                          </span>
                          {c.owner && customerDict[c.owner] && (
                            <div className="company-info">{`${customerDict[c.owner].name}`}</div>
                          )}
                        </span>
                        {c.vehicle?.licensePlate?.licenseNumber && (
                          <LicencePlateFlag
                            licenceNumber={c.vehicle?.licensePlate.licenseNumber}
                            countryCode={c.vehicle?.licensePlate.country}
                            width="12"
                            height="14"
                          />
                        )}
                      </span>
                    </NavLink>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }

  handleDocumentClick = (e: any) => {
    if (!!this.resultsRef?.current && this.resultsRef?.current?.contains(e?.target)) {
      this.setState({
        resultsDisplay: true,
      })
      return
    }
    if (!this.resultsRef?.current?.contains(e?.target) || this.resultsRef?.current?.contains(e?.target)) {
      this.setState({
        resultsDisplay: false,
      })
    }
  }

  private handleChange(value: ContractViewModel, e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    e.preventDefault()
    this.props.changeTrigger?.(value)
    this.contractsSearchChanged(undefined, undefined, value.vehicle?.licencePlate?.licenseNumber)
  }

  private customersDictByUnit() {
    const dict: { [id: string]: ICustomerViewModel } = {}
    this.props.customers?.forEach((c) => {
      c.units.forEach((u) => {
        dict[u.path] = c
      })
    })
    return dict
  }

  private onKeyDownEvent2(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      this.contractsSearchChanged(e as any, true)
      return
    }
    if (e.key === 'Backspace' && this.state.contractsSearchString?.length === 0) {
      e.preventDefault()
    }
  }

  private highlightText(text, highlight) {
    if (text) {
      const highlightTxt = highlight || ''
      const escapedHighlight = highlightTxt.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'))
      return (
        <span>
          {parts.map((part, key) =>
            part.toLowerCase() === highlightTxt.toLowerCase() ? (
              <span key={key} className="highlighted">
                {part}
              </span>
            ) : (
              part
            )
          )}
        </span>
      )
    } else {
      return text
    }
  }

  private contractsSearchChanged(event?: any, instant?: boolean, displayValue?: string) {
    if (displayValue) {
      this.setState({
        contractsSearchStringToUse: '',
        contractsSearchString: displayValue,
        contractsSearcResults: [],
      })
      return
    }
    const value = event ? event.target.value : ''
    if (value === '' && this.props.searchDeleted) {
      this.props.searchDeleted(value)
    }
    this.setState({
      contractsSearchString: value,
      contractsSearcResults: value && value?.length >= 3 ? this.state.contractsSearcResults : [],
    })
    const newDebounce = { ...this.state.contractsSearchDebounce }
    if (newDebounce.timeout) {
      clearTimeout(newDebounce.timeout)
      newDebounce.timeout = undefined
    }

    const mainTimeoutFunc = () => {
      this.setState({
        contractsSearchDebounce: {
          ...this.state.contractsSearchDebounce,
          change: new Date().getTime(),
        },
      })
    }

    if (value && value?.length > 0 && !instant) {
      newDebounce.timeout = window.setTimeout(mainTimeoutFunc, 2000)
      this.setState({
        contractsSearchDebounce: newDebounce,
      })
    } else {
      this.setState({
        contractsSearchDebounce: newDebounce,
      })
      mainTimeoutFunc()
    }
  }
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */

function mapStateToProps({ appData, customers, contracts }: State) {
  return {
    customers: customers.customers,
    appData,
    stats: contracts.stats,
  }
}

const mapDispatchToProps = {
  searchContracts: wrapQuery((searchTerm?: string, activeOnly?: boolean) =>
    contractsApi.endpoints.searchContracts.initiate({ searchTerm, activeOnly })
  ),
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(ContractsSearchComponent))
